var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import { useOpenThreadHandler, useUserRole } from './hooks';
import { ReactionIcon, ThreadIcon } from './icons';
import { MESSAGE_ACTIONS } from './utils';
import { MessageActions } from '../MessageActions';
import { useChannelContext } from '../../context/ChannelContext';
var UnMemoizedMessageOptions = function (props) {
    var _a;
    var _b = props.displayActions, displayActions = _b === void 0 ? true : _b, _c = props.displayLeft, displayLeft = _c === void 0 ? true : _c, _d = props.displayReplies, displayReplies = _d === void 0 ? true : _d, getMessageActions = props.getMessageActions, propHandleOpenThread = props.handleOpenThread, initialMessage = props.initialMessage, message = props.message, messageWrapperRef = props.messageWrapperRef, onReactionListClick = props.onReactionListClick, _e = props.theme, theme = _e === void 0 ? 'simple' : _e, threadList = props.threadList;
    var channel = useChannelContext().channel;
    var handleOpenThread = useOpenThreadHandler(message);
    var isMyMessage = useUserRole(message).isMyMessage;
    var channelConfig = (_a = channel === null || channel === void 0 ? void 0 : channel.getConfig) === null || _a === void 0 ? void 0 : _a.call(channel);
    var messageActions = getMessageActions();
    var shouldShowReactions = messageActions.indexOf(MESSAGE_ACTIONS.react) > -1 && channelConfig && channelConfig.reactions;
    var shouldShowReplies = messageActions.indexOf(MESSAGE_ACTIONS.reply) > -1 &&
        displayReplies &&
        !threadList &&
        channelConfig &&
        channelConfig.replies;
    if (!message ||
        message.type === 'error' ||
        message.type === 'system' ||
        message.type === 'ephemeral' ||
        message.status === 'failed' ||
        message.status === 'sending' ||
        initialMessage) {
        return null;
    }
    if (isMyMessage && displayLeft) {
        return (React.createElement("div", { className: "str-chat__message-" + theme + "__actions", "data-testid": 'message-options-left' },
            displayActions && React.createElement(MessageActions, __assign({}, props, { messageWrapperRef: messageWrapperRef })),
            shouldShowReplies && (React.createElement("div", { className: "str-chat__message-" + theme + "__actions__action str-chat__message-" + theme + "__actions__action--thread", "data-testid": 'thread-action', onClick: propHandleOpenThread || handleOpenThread },
                React.createElement(ThreadIcon, null))),
            shouldShowReactions && (React.createElement("div", { className: "str-chat__message-" + theme + "__actions__action str-chat__message-" + theme + "__actions__action--reactions", "data-testid": 'message-reaction-action', onClick: onReactionListClick },
                React.createElement(ReactionIcon, null)))));
    }
    return (React.createElement("div", { className: "str-chat__message-" + theme + "__actions", "data-testid": 'message-options' },
        shouldShowReactions && (React.createElement("div", { className: "str-chat__message-" + theme + "__actions__action str-chat__message-" + theme + "__actions__action--reactions", "data-testid": 'message-reaction-action', onClick: onReactionListClick },
            React.createElement(ReactionIcon, null))),
        shouldShowReplies && (React.createElement("div", { className: "str-chat__message-" + theme + "__actions__action str-chat__message-" + theme + "__actions__action--thread", "data-testid": 'thread-action', onClick: propHandleOpenThread || handleOpenThread },
            React.createElement(ThreadIcon, null))),
        displayActions && React.createElement(MessageActions, __assign({}, props, { messageWrapperRef: messageWrapperRef }))));
};
export var MessageOptions = React.memo(UnMemoizedMessageOptions);
